import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterFace, discountSectionsInterface} from "./discounstInterface";
import {setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";

class Discount extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  render() {
    const {discount} = this.props;
    const disabled = this.isDiscountDisabled();
    return (
      <li className={"discount" + (disabled ? " discount--disabled" : "")}>
        <div className="discount-cell discount-cell--select">
          <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                  onClick={this.handleDiscountSelectClick}/>
        </div>
        <div className="discount-cell discount-cell--name" onClick={this.handleDiscountSelectClick}>
          {discount.selected ? discount.name : null}
        </div>
        {discount.selected ? (
          <div className="discount-cell discount-cell--amount">
            {this.getDiscountAmount()}
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts} = store.priceWorksheetState;
  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
